import React, {useState, useEffect} from "react";
import { HiBars3, HiUser } from "react-icons/hi2";
import useBatchInfoGet from "../../../api-definition/useBatchInfoGet";
import useHelpInformationGet from "../../../api-definition/useHelpInformationGet";
import "./style.css";
import Form from "../form/Form";
import UserPageComponents from "../UserPageComponents";
import { getCookie } from "../../../utils/cookieUtils";
import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { Modal } from "@mui/material";


const HeaderBar = (props) => {
  const username = getCookie("X-Spl-Username-Header");
  const {batchNames, batchIds} = useBatchInfoGet(username);
  const helpInfo = useHelpInformationGet();
  const [replayCount, setReplayCount] = useState(0);
  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const [isUserPageActive, setIsUserPageActive] = useState(false);
  const [isNoBatchesModalOpen, setNoBatchesModalOpen] = useState(false);
  
  const [soundContextData, setSelectedSoundContext] = useState(null);
  const [helpData, setSelectedHelp] = useState(null);
  const [isHelpModalOpen, setHelpModalOpen] = useState(false);

  const handleHelpOptionClick = (soundContext, help) => {
    setSelectedSoundContext(soundContext);
    setSelectedHelp(help);
    setHelpModalOpen(true);
  };
  
  const handleCloseHelpModal = () => {
    setSelectedSoundContext(null);
    setSelectedHelp(null);
    setHelpModalOpen(false);
  };

  useEffect(() => {
    if (!isUserPageActive){
      if (batchIds && batchIds.length > 0) {
        props.onBatchIdChange(batchIds[0]);
      }
      if (batchIds.length === 0) {
        const delayTimeout = setTimeout(() => {
          setNoBatchesModalOpen(true);
        }, 5000);

        // Cleanup the timeout when the component unmounts or when batchIds changes
        return () => clearTimeout(delayTimeout);
      }
    } else {
      props.onBatchIdChange(selectedBatchId);
    }
  }, [batchIds]);

  const handleBatchNameClick = (index) => {
    setIsUserPageActive(true);
    setSelectedBatchId(batchIds[index]);
    props.onBatchIdChange(batchIds[index]);
  };

  const handleBackToHomePage = () => {
    setSelectedBatchId(null);
    setIsUserPageActive(false);
  };
  
  const handleCloseNoBatchesModal = () => {
    setNoBatchesModalOpen(false);
  };

  return (
    <div style={{ backgroundColor: "#000E54", padding: "5px 10px" , display: "flex"}}>
      <div class="dropdown_HB">
        <button class="dropbtn_HB">
          <HiBars3 />
          <i class="fa fa-caret-down"></i>
        </button>
        <div class="dropdown-content">
        {batchNames.map((batchName, index) => (
            <div
              onClick={() => handleBatchNameClick(index)}
              className="batch-name-click"
            >
              {batchName}
            </div>
          ))}
        </div>
      </div>
      <div class ="textall_HB">
        <Link to="/" style={{ textDecoration: "none" }}>
          <div className="speech_HB">{"Speech App"}</div>
        </Link>
        <div class="dropdown_HB">
          <button class="dropbtn_HB" style={{ fontSize: "20px" }}>
            Help <i class="fa fa-caret-down"></i>
          </button>
          <div class="dropdown-content">
            {helpInfo.map((contextData, index) => (
              <div
                key={index}
                onClick={() => handleHelpOptionClick(contextData.sound_context, contextData.help)}
                className="batch-name-click"
              >
                {contextData.sound_context}
              </div>
            ))}
          </div>
        </div>
        
        {isHelpModalOpen && (
        <Dialog open={isHelpModalOpen} onClose={handleCloseHelpModal}>
          <DialogContent>
          <div style={{ border: "5px solid", borderColor: "#000E54", fontSize: "12px", color: "#000E54"}}>
            <div style={{ textAlign: "left", padding: "0px 10px", fontSize: "15px", color: "#000E54"}}>
              <h3>Sound Context: {soundContextData}</h3>
            </div>
            {
              Object.keys(helpData).map((key) => (
                <div style={{ textAlign: "left", padding: "0px 10px", fontSize: "12px", color: "#000E54"}} key={key}>
                  <h3>{key} . {helpData[key].text} : </h3>
                    {helpData[key].info}
                </div>
              ))           
           }
          </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseHelpModal} variant="contained" color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
        )}
       
        <div class="uicon_userpage">
          Welcome {username}! <HiUser />
        </div> 
      </div> 
      
      {isNoBatchesModalOpen && (
        <Dialog open={isNoBatchesModalOpen} onClose={handleCloseNoBatchesModal}>
          <DialogContent>
            <div style={{ color: "#000E54", textAlign: "center" }}>
              No batches to rate currently.
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseNoBatchesModal} variant="contained" color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
      
    </div>
  );
};

export default HeaderBar;
